export const CHANGE_ZOOID = 'CHANGE_ZOOID';
export const CHANGE_ZOONAME = 'CHANGE_ZOONAME';
export const TOGGLE_ANONYMOUS = 'TOGGLE_ANONYMOUS';
export const TOGGLE_ANONYMOUS_PHOTOS = 'TOGGLE_ANONYMOUS_PHOTOS';
export const SET_ZOO_TIER = 'SET_ZOO_TIER';
export const SET_USER_ROLE = 'SET_USER_ROLE';
export const SET_ZONE_FILTER = 'SET_ZONE_FILTER';
export const SET_USER_FILTER = 'SET_USER_FILTER';
export const SET_ZOO_TIMEZONE = 'SET_ZOO_TIMEZONE';
export const SET_ZOO_OPTIONS = 'SET_ZOO_OPTIONS';
export const SET_ZOO_TYPE = 'SET_ZOO_TYPE';
export const SET_AKONGO_STAFF = 'SET_AKONGO_STAFF';
/**
 * Change a setting value
 * payload.name: name of the setting prop to change
 * payload.value: new value to apply
 */
export function changeZooId(name, value) {
    return { type: CHANGE_ZOOID, name, value };
}

export function changeZooName(name, value) {
    return { type: CHANGE_ZOONAME, name, value };
}

export function toggleAnonymous(value) {
    return { type: TOGGLE_ANONYMOUS, value };
}

export function toggleAnonymousPhotos(value) {
    return { type: TOGGLE_ANONYMOUS_PHOTOS, value };
}

export function setZooTier(value) {
    return { type: SET_ZOO_TIER, value };
}

export function setUserRole(value) {
    return { type: SET_USER_ROLE, value };
}

export function setZoneFilter(value) {
    return { type: SET_ZONE_FILTER, value };
}

export function setUserFilter(value) {
    return { type: SET_USER_FILTER, value };
}

export function setZooTimezone(value) {
    return { type: SET_ZOO_TIMEZONE, value };
}

export function setZooOptions(value) {
    return { type: SET_ZOO_OPTIONS, value };
}

export function setZooType(value) {
    // Normalize to plain string — Firestore stores {value: "zoo"|"lab"|"projet"}
    const normalized = value && typeof value === 'object' ? value.value : value;
    return { type: SET_ZOO_TYPE, value: normalized || null };
}

/**
 * Flag `akongoStaff` du profil authentifié (users/{uid}.akongoStaff), posé au
 * login et resynchronisé au boot de la Sidebar. C'est le seul critère d'accès
 * à l'interface V2 : aucune policy distante n'est consultée.
 */
export function setAkongoStaff(value) {
    return { type: SET_AKONGO_STAFF, value: value === true };
}




